import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Row, Col, Button, Image, OverlayTrigger, Tooltip, Dropdown, Table, } from 'react-bootstrap';
import { MoreVertical, X } from 'lucide-react'
import { CSVLink } from "react-csv";
import { useReactToPrint } from 'react-to-print';
import ReactTable, { filterDateRange, DateRangeFilter } from '../../../Shared/ReactTable/ReactTable';
import callAPI from '../../../../commonservices/APIRequests';
import filterlogo from '../../../../assets/images/TableFilters/TableFilterIcon.svg';
import printlogo from '../../../../assets/images/TableFilters/TableFilterPrintIcon.svg';
import exportlogo from '../../../../assets/images/TableFilters/TableFilterDownloadIcon.svg';
import TableFiltersWrapper from '../../../Shared/common/components/TableComponents/TableFiltersWrapper/TableFiltersWrapper';
import NoDataFound from '../../../Shared/common/components/TableComponents/NoDataFound/NoDataFound';
import logo from '../../../../assets/images/logo.png';
import { convertToBaseFormatDate } from '../../../../commonservices/CommonMethods';
import { useDispatch } from "react-redux";
import ConfirmationPopup from '../../../Shared/common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup';
import unAssign from '../../../../assets/images/Menu-Icon/un-assign-action.svg'
import { lenderBanner } from '../../../../store/Actions/Lender/CommonAction/CommonAction';
import Loader from '../../Loader/Loader';


let csvData = [];
let printRT = [];

const LenderBanner = (props) => {

    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const printRef = useRef();
    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    const [showLoader, setShowLoader] = useState(false)
    const [rerenderCSVData, setRerenderCSVData] = useState();
    const [rerenderPrintData, setRerenderPrintData] = useState();
    const [showFilters, setShowFilters] = useState(false);
    const [selectedBannerData, setSelectedBannerData] = useState({})
    const [columns, setColumns] = useState([]);
    const [deletePopUp, setDeletePopUp] = useState(false);
    const dispatch = useDispatch();

    const setCSVData = (filteredData) => {


        csvData = filteredData.map(item => {
            return {
                BannerHeader: item.header,
                Subject: item.subject,
                Body: item.body,
                BannerType: item.bannerType,
                TaskType: item.taskType,
                StartDate: convertToBaseFormatDate(item.startDate, true, false),
                EndDate: convertToBaseFormatDate(item.endDate, true, false),
            }

        });

        printRT = filteredData.map((data, index) => {
            return (<tr key={'BannerList' + index}>
                <td className="pl-3">
                    <p className="mb-0">{data.body}</p>
                </td>
                <td className="pl-3">
                    <p className="mb-0">{convertToBaseFormatDate(data.startDate, true, false)}</p>
                </td>
                <td className="pl-3">
                    <p className="mb-0">{convertToBaseFormatDate(data.endDate, true, false)}</p>
                </td>
            </tr>)
        });

    };

    const setFilteredData = useCallback(() => {
        setCSVData(props.LenderData ? props.LenderData : csvData)
    }, [props.LenderData]);


    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });


    useEffect(() => {
        if (rerenderPrintData !== undefined)
            handlePrint();

    }, [rerenderPrintData]);

    useEffect(() => {

        setColumns([
            {
                Header: 'Notes',
                accessor: 'body',
                className: 'notes-in-table',
                Cell: props => <span className='text-capitalize'>{props.value}</span>
            },
            {
                Header: 'Banner Type',
                accessor: row => row.bannerType === "non-gated" ? "non gated" : row.bannerType,
                Cell: props => <span className='text-capitalize'>{props.value}</span>
            },
            {
                Header: 'Task Type',
                accessor: 'taskType',
                Cell: props => <span className='text-capitalize'>{props.value}</span>
            },
            {
                Header: 'Start Date',
                accessor: 'startDate',
                className: 'start-date-in-table',
                filter: filterDateRange,
                Filter: DateRangeFilter,
                Cell: props => convertToBaseFormatDate(props.value, true, false)
            },
            {
                Header: 'End Date',
                accessor: 'endDate',
                className: 'end-date-in-table',
                filter: filterDateRange,
                Filter: DateRangeFilter,
                Cell: props => convertToBaseFormatDate(props.value, true, false)
            },
            {
                Header: 'Actions',
                accessor: '',
                filter: '',
                Filter: '',
                Cell: props => <React.Fragment>
                    <Dropdown className="default-table-actions-dd">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            <MoreVertical className="cursor-pointer" size={16} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='content-text-14px' popperConfig={{ strategy: 'fixed' }}
                            popperModifiers={{ flip: { behavior: ["bottom"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }}>
                            <Dropdown.Item onClick={() => deletePopup(props.row.original)}>
                                <span><Image src={unAssign} alt='approve' /></span>
                                <span>Unassign</span>
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                </React.Fragment>
            },
        ])

    }, [props.LenderData]);


    const deletePopup = (data) => {
        setDeletePopUp(true)
        setSelectedBannerData(data)
    }

    const onCancelRemoveCartPopUp = () => {
        setSelectedBannerData({})
        setDeletePopUp(false)
    }
    const deleteBanner = () => {
        setDeletePopUp(true)
        const req = {
            sopraReference: selectedBannerData?.sopraDealerReference || selectedBannerData?.sopraSupplierReference,
            bannerId: selectedBannerData?.bannerId
        }
        setShowLoader(true)
        return callAPI.post('/lender/api/v1/banner/deleteBanner', req)
            .then((response) => {

                if (response.status === 200) {
                    setShowLoader(false)
                    setDeletePopUp(false)
                    if (props.selectedDealer?.sopraDealerReference ?? props.selectedDealer?.dealerReference) {
                        
                        dispatch(lenderBanner(props.selectedDealer?.dealerId, props.selectedDealer?.sopraDealerReference ?? props.selectedDealer?.dealerReference ?? ''))
                    }else if (props.selectedDealer?.sopraSupplierReference ?? props.selectedDealer?.supplierReference) {
                        
                        dispatch(lenderBanner(props.selectedDealer?.dealerId, props.selectedDealer?.sopraSupplierReference ?? props.selectedDealer?.supplierReference ?? ''), true)
                    }

                    props.setToaster({
                        showToaster: true,
                        content: `Banner successfully unassigned to ${props.selectedDealer.dealerName}.`,
                        header: 'Success',
                        class: 'success-toaster'
                    })

                }
                else {
                    setDeletePopUp(false)
                    setShowLoader(false)
                    props.setToaster({
                        showToaster: true,
                        content: response.message,
                        header: 'Error',
                        class: 'error-toaster'
                    })

                }

            })

    }

    return (
        <div className={`lender-banner-notes-wrapper ${userDetails.readOnlyAccess ? 'read-only-access' : ''}`}>
            {showLoader ? <Loader show={showLoader} styleType='fixed' /> : null}
            <TableFiltersWrapper>
                <OverlayTrigger placement="bottom"
                    overlay={
                        <Tooltip>Filter</Tooltip>}>
                    <Button className="action-item anchor-btn" onClick={() => setShowFilters(!showFilters)}>
                        <img src={filterlogo} alt="filterlogo" />
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom"
                    overlay={
                        <Tooltip>Print</Tooltip>}>
                    <Button
                        onClick={() => setRerenderPrintData(!rerenderPrintData)}
                        className="action-item anchor-btn">
                        <img src={printlogo} alt="printlogo" />
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom"
                    overlay={
                        <Tooltip>Download</Tooltip>}>
                    <CSVLink asyncOnClick={true}
                        onClick={() => setRerenderCSVData(!rerenderCSVData)} data={csvData} filename={"BannerList.csv"}
                        className="action-item" target="_blank">
                        <img src={exportlogo} alt="exportlogo" />
                    </CSVLink>
                </OverlayTrigger>
            </TableFiltersWrapper>

            <Row className="default-cs-table actionsItemsTable">
                {props.LenderData && props.LenderData.length > 0 ?
                    <Col>
                        <ReactTable
                            columns={userDetails.readOnlyAccess ? columns.filter(column => !['Actions', 'Banner Type', 'Task Type'].includes(column?.Header)) : columns.filter(column => !['Banner Type', 'Task Type'].includes(column?.Header))} data={props.LenderData} autoResetFilters={!showFilters}
                            autoResetGlobalFilter={!showFilters}
                            showFilters={showFilters}
                            filteredDataSync={(items) => setFilteredData(items)}
                        />
                    </Col>
                    : <NoDataFound message={props.showLoader ? 'Data is processing' : 'No Records Found'} />}
            </Row>

            <div className="myinventory-table d-none">
                <Row ref={printRef}>
                    <Col xs={12}>
                        <Row className="mb-3 align-items-center">
                            <Col xs={4}>
                                <Image width={80} src={partnerDetails && partnerDetails.partnerLogo ? partnerDetails.partnerLogo : logo} fluid />
                            </Col>
                            <Col xs={4} className="prinTableHeading text-center position-absolute">
                                <h3>Banners List</h3>
                                Lender : {userDetails ? userDetails.dealerName : ''}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} className="left-align-table">
                        <Table>
                            <thead className="table-header-bg-color pt-2 pb-2">
                                <tr>
                                    <th className="pl-3">Notes</th>
                                    <th className="pl-3">Start Date</th>
                                    <th className="pl-3">End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {printRT}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
            <ConfirmationPopup
                title="Are you sure want to Unassign Banner?"
                onClose={() => onCancelRemoveCartPopUp()}
                showModal={deletePopUp}
                showPopupLoader={false}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={(event) => deleteBanner()}
                secondaryAction={() => onCancelRemoveCartPopUp()}
            />
        </div>
    )

}

export default LenderBanner;